import React from 'react';
import {
    Div,
    Title,
    Button,
    Avatar,
    ModalRoot,
    ModalPage,
    ModalPageHeader,
    PanelHeaderButton,
    SimpleCell,
    SplitLayout,
    SplitCol
} from '@vkontakte/vkui';

import {
    Icon16Clear,
    Icon20ListPenOutline,
    Icon24CameraOutline,
    Icon24Cancel,
    Icon28PicturePlusOutline,
    Icon20RotateRight,
    Icon20RotateLeft
} from "@vkontakte/icons";

import {AdaptivityContext, getGUID} from "../assets/constants";
import Fancybox from "../assets/fancybox";
import * as constants from "../assets/constants";
import BaseComponent from "./BaseComponent";
import ImageRotationApi from "../api/ImageRotationApi";

import TakeAPhotoToQueue from "./TakeAPhotoToQueue";
import PhotoWrapper from "../utils/PhotoWrapper";

const MODAL_CHANGE_ANGLE = 'modal_change_angle';

class PhotoGallery extends BaseComponent {

    constructor(props) {
        super(props);
        this.imageTimestamps = {}; // Хранилище timestamp'ов для каждого изображения
        this.state = {
            numImage: 0,
            changeAngleKey: null
        };
    }

    componentDidMount() {
        super.componentDidMount();
        // Инициализируем timestamp'ы для существующих изображений
        this.initializeImageTimestamps();
    }

    componentDidUpdate(prevProps) {
        // Переинициализируем timestamp'ы если изображения изменились
        if (prevProps.images !== this.props.images) {
            this.initializeImageTimestamps();
        }
    }

    initializeImageTimestamps = () => {
        const {images} = this.props;
        const timestamp = new Date().getTime();

        if (Array.isArray(images)) {
            images.forEach((item, index) => {
                if (item && item.hasImage) {
                    this.imageTimestamps[index] = timestamp;
                }
            });
        } else if (typeof images === 'object' && images !== null) {
            Object.keys(images).forEach(key => {
                if (images[key] && images[key].hasImage) {
                    this.imageTimestamps[key] = timestamp;
                }
            });
        }
    }

    clearPhoto = (key) => {
        // В режиме readOnly не позволяем удалять изображения
        if (this.props.readOnly) {
            return;
        }

        const {images, onImagesChange} = this.props;
        let updatedImages;

        if (Array.isArray(images)) {
            updatedImages = [...images];
            if (updatedImages[key] !== undefined) {
                updatedImages.splice(key, 1);
            }
        } else {
            updatedImages = {...images};
            if (updatedImages[key] !== undefined) {
                delete updatedImages[key];
            }
        }

        if (onImagesChange) {
            onImagesChange(updatedImages);
        }
    }

    // Функция для извлечения destination из пути к файлу
    getDestinationFromImagePath = (imagePath) => {
        const match = imagePath.match(/\/uploads\/([^\/]+)\//);
        return match ? match[1] : (this.props.destination || 'monitoring');
    }

    rotatePhoto = async (key, direction = 'right') => {
        // В режиме readOnly не позволяем поворачивать изображения
        if (this.props.readOnly) {
            return;
        }

        const {images, onImagesChange, base_url} = this.props;
        const images_url = base_url.replace("frontend/", '');

        const currentImage = Array.isArray(images) ? images[key] : images[key];

        if (currentImage && currentImage.hasImage) {
            try {
                // Показываем индикатор загрузки
                window.postMessage({type: 'loader', value: true});

                let timestamp = new Date().getTime();
                let imageSrc = images_url + currentImage.mainImage.replace('https:/l', 'https://l').replace('https://lab.scladro.ru', '').replace(images_url, '');

                // Добавляем timestamp к оригинальному изображению для сброса кеша
                imageSrc += imageSrc.includes('?') ? '&t=' + timestamp : '?t=' + timestamp;

                // Извлекаем имя файла из URL
                const filename = currentImage.mainImage.split('/').pop();

                // Определяем destination из пути к изображению
                const destination = this.getDestinationFromImagePath(currentImage.mainImage);

                // Поворачиваем изображение
                const result = await ImageRotationApi.rotateImage(imageSrc, filename, direction, destination);

                if (result && result.data) {
                    timestamp = new Date().getTime();
                    // Файл перезаписан, обновляем timestamp для этого изображения
                    this.imageTimestamps[key] = timestamp;

                    // Обновляем thumbnail с новым timestamp для сброса кеша
                    let thumbUrl = currentImage.thumb;
                    thumbUrl = thumbUrl.replace(/[&?]t=\d+/g, '').replace('https:/l', 'https://l').replace('https://lab.scladro.ru', '').replace(images_url, '');
                    thumbUrl += thumbUrl.includes('?') ? '&t=' + timestamp : '?t=' + timestamp;

                    let mainImage = currentImage.mainImage;
                    mainImage = mainImage.replace(/[&?]t=\d+/g, '').replace('https:/l', 'https://l').replace('https://lab.scladro.ru', '').replace(images_url, '');

                    const updatedImage = {
                        ...currentImage,
                        mainImage,
                        thumb: thumbUrl
                    };

                    let updatedImages;
                    if (Array.isArray(images)) {
                        updatedImages = [...images];
                        updatedImages[key] = updatedImage;
                    } else {
                        updatedImages = {...images};
                        updatedImages[key] = updatedImage;
                    }

                    if (onImagesChange) {
                        onImagesChange(updatedImages);
                    }

                    // Вызываем коллбек после поворота изображения
                    if (this.props.onImageRotated) {
                        this.props.onImageRotated(key, updatedImage, updatedImages);
                    }

                    window.postMessage({
                        type: 'success',
                        hideSpinner: true,
                        text: 'Изображение успешно повернуто',
                        timeout: 1500
                    });
                    this.setState({});
                } else {
                    window.postMessage({type: 'error', text: 'Ошибка при повороте изображения'});
                }
            } catch (error) {
                console.error('Ошибка поворота изображения:', error);
                window.postMessage({type: 'error', text: 'Ошибка при повороте изображения: ' + error.message});
            } finally {
                window.postMessage({type: 'loader', value: false});
            }
        }
    }

    getPhoto = (key) => {
        // В режиме readOnly не позволяем добавлять/изменять изображения
        if (this.props.readOnly) {
            return;
        }

        this.setState({numImage: key});
        if (this.props.onTakePhoto) {
            this.props.onTakePhoto(key);
        }
        this.setActiveModal(constants.MODAL_TAKE_A_PHOTO);
    }

    openChangeAngle = (key) => {
        if (this.props.readOnly) return;
        const angles = this.props.angles || [];
        if (!angles.length) return;
        this.setState({changeAngleKey: key});
        this.setActiveModal(MODAL_CHANGE_ANGLE);
    }

    applyChangeAngle = (angleId) => {
        const key = this.state.changeAngleKey;
        const {images, onImagesChange, onChangeAngle} = this.props;
        if (key === null || key === undefined) {
            this.setActiveModal(null);
            return;
        }

        if (onChangeAngle) {
            onChangeAngle(key, Number(angleId));
            this.setState({changeAngleKey: null});
            this.setActiveModal(null);
            return;
        }

        let updatedImages;
        if (Array.isArray(images)) {
            updatedImages = [...images];
            if (updatedImages[key]) {
                updatedImages[key] = {...updatedImages[key], angle_id: Number(angleId)};
            }
        } else {
            updatedImages = {...images};
            if (updatedImages[key]) {
                updatedImages[key] = {...updatedImages[key], angle_id: Number(angleId)};
            }
        }

        if (onImagesChange) {
            onImagesChange(updatedImages);
        }
        this.setState({changeAngleKey: null});
        this.setActiveModal(null);
    }

    receiveMessage = (event) => {
        // В режиме readOnly не обрабатываем события изменения изображений
        if (this.props.readOnly) {
            return;
        }

        const {images, onImagesChange, base_url, eventName, multipleEventName} = this.props;
        const images_url = base_url.replace("frontend/", '');

        // Обработка одиночного изображения
        if (event.data.type === eventName) {
            let updatedImages;
            let old = {};

            if (Array.isArray(images)) {
                updatedImages = [...images];
                if (updatedImages[this.state.numImage] !== undefined) {
                    old = updatedImages[this.state.numImage];
                }
            } else {
                updatedImages = {...images};
                if (updatedImages[this.state.numImage] !== undefined) {
                    old = updatedImages[this.state.numImage];
                }
            }

            old.hasImage = true;
            old.mainImage = event.data.data.image.replace('https:/l', 'https://l').replace('https://lab.scladro.ru', '').replace(images_url, '');
            old.thumb = event.data.data.thumb.replace('https:/l', 'https://l').replace('https://lab.scladro.ru', '').replace(images_url, '');
            old.datetime = new Date();
            if (event.data.data.angle_id !== undefined && event.data.data.angle_id !== null) {
                old.angle_id = Number(event.data.data.angle_id);
            } else if (this.props.angleId !== undefined && this.props.angleId !== null) {
                old.angle_id = Number(this.props.angleId);
            }

            updatedImages[this.state.numImage] = old;

            if (onImagesChange) {
                onImagesChange(updatedImages);
            }

            // Вызываем коллбек после добавления нового изображения
            if (this.props.onImageAdded) {
                this.props.onImageAdded(this.state.numImage, old, updatedImages);
            }

            this.setState({});
        }

        // Обработка множественных изображений
        const multipleEvent = multipleEventName || (eventName + '_multiple');
        if (event.data.type === multipleEvent) {
            const receivedImages = event.data.data.images;
            if (!receivedImages || !Array.isArray(receivedImages)) {
                return;
            }

            let updatedImages;
            const startPosition = this.state.numImage;

            if (Array.isArray(images)) {
                updatedImages = [...images];
                
                // Вставляем изображения начиная с позиции startPosition
                receivedImages.forEach((imageData, index) => {
                    const position = startPosition + index;
                    
                    // Если позиция выходит за пределы массива, добавляем элементы
                    while (updatedImages.length <= position) {
                        updatedImages.push({hasImage: false});
                    }
                    
                    const newImageObj = {
                        hasImage: true,
                        mainImage: imageData.image.replace('https:/l', 'https://l').replace('https://lab.scladro.ru', '').replace(images_url, ''),
                        thumb: imageData.thumb.replace('https:/l', 'https://l').replace('https://lab.scladro.ru', '').replace(images_url, ''),
                        datetime: new Date(),
                        angle_id: imageData.angle_id !== undefined && imageData.angle_id !== null
                            ? Number(imageData.angle_id)
                            : (this.props.angleId !== undefined && this.props.angleId !== null
                                ? Number(this.props.angleId) : 0)
                    };
                    
                    updatedImages[position] = newImageObj;
                });
            } else {
                updatedImages = {...images};
                
                // Для объектов используем numImage как базовый ключ
                receivedImages.forEach((imageData, index) => {
                    const key = startPosition + index;
                    
                    const newImageObj = {
                        hasImage: true,
                        mainImage: imageData.image.replace('https:/l', 'https://l').replace('https://lab.scladro.ru', '').replace(images_url, ''),
                        thumb: imageData.thumb.replace('https:/l', 'https://l').replace('https://lab.scladro.ru', '').replace(images_url, ''),
                        datetime: new Date(),
                        angle_id: imageData.angle_id !== undefined && imageData.angle_id !== null
                            ? Number(imageData.angle_id)
                            : (this.props.angleId !== undefined && this.props.angleId !== null
                                ? Number(this.props.angleId) : 0)
                    };
                    
                    updatedImages[key] = newImageObj;
                });
            }

            if (onImagesChange) {
                onImagesChange(updatedImages);
            }

            // Вызываем коллбек после добавления множественных изображений
            if (this.props.onMultipleImagesAdded) {
                this.props.onMultipleImagesAdded(startPosition, receivedImages, updatedImages);
            }

            this.setState({});
        }
    }

    getNextKey = () => {
        const {images} = this.props;
        if (Array.isArray(images)) {
            return images.length;
        } else {
            let maxId = 0;
            Object.keys(images || {}).forEach(id => {
                if (maxId < id * 1) maxId = id * 1;
            });
            return maxId + 1;
        }
    }

    renderImage = (item, key) => {
        const {base_url, usePhotoWrapper = true, fancyboxGroup = 'gallery', readOnly = false} = this.props;
        const images_url = base_url.replace("frontend/", '');

        if (!item || !item.hasImage) {
            // В режиме readOnly не показываем пустые изображения
            if (readOnly) {
                return null;
            }
            return (
                <Avatar
                    mode="image"
                    style={{borderRadius: '5%'}}
                    onClick={() => this.getPhoto(key)}
                    size={AdaptivityContext.isMobile ? 100 : 260}
                    src={images_url + constants.EMPTY_IMG}
                />
            );
        }

        const timestamp = this.imageTimestamps[key] || new Date().getTime();
        const mainImageUrl = images_url + item.mainImage.replace('https:/l', 'https://l').replace('https://lab.scladro.ru', '').replace(images_url, '');
        const fullImageUrl = mainImageUrl + (mainImageUrl.includes('?') ? '&t=' + timestamp : '?t=' + timestamp);

        let thumbUrl = item.thumb;
        thumbUrl = thumbUrl.replace(/[&?]t=\d+/g, '').replace('https:/l', 'https://l').replace('https://lab.scladro.ru', '').replace(images_url, '');
        const thumbFullUrl = images_url + thumbUrl + (thumbUrl.includes('?') ? '&t=' + timestamp : '?t=' + timestamp);

        const ImageComponent = usePhotoWrapper ? PhotoWrapper : Avatar;

        const imageElement = (
            <a key={`image-${key}`} data-fancybox={fancyboxGroup} href={fullImageUrl}>
                <ImageComponent
                    mode="image"
                    style={{borderRadius: '5%', display: 'block'}}
                    size={AdaptivityContext.isMobile ? 120 : 260}
                    src={thumbFullUrl}
                />
            </a>
        );

        // В режиме readOnly возвращаем только изображение без кнопок управления
        if (readOnly) {
            return imageElement;
        }

        const angles = this.props.angles || [];
        const canChangeAngle = angles.length > 0;
        const isMobile = AdaptivityContext.isMobile;
        const thumbSize = isMobile ? 120 : 260;

        const overlayTop = (
            <div className="gallery-thumb__overlay gallery-thumb__overlay--top" key={`overlay-${key}`}>
                <Button mode="primary" size="m" className="btn-gallery-actions"
                        onClick={() => this.getPhoto(key)}
                        before={<Icon24CameraOutline/>}
                />
                {!isMobile && canChangeAngle &&
                    <Button mode="primary" size="m" className="btn-gallery-actions"
                            onClick={() => this.openChangeAngle(key)}
                            before={<Icon20ListPenOutline/>}
                            aria-label="Сменить ракурс"
                    />}
                {!isMobile &&
                    <Button mode="primary" size="m" className="btn-gallery-actions"
                            onClick={() => this.rotatePhoto(key, 'right')}
                            before={<Icon20RotateRight/>}
                    />}
                {!isMobile &&
                    <Button mode="primary" size="m" className="btn-gallery-actions"
                            onClick={() => this.rotatePhoto(key, 'left')}
                            before={<Icon20RotateLeft/>}
                    />}
                <Button mode="primary" size="m" className="btn-gallery-actions"
                        onClick={() => this.clearPhoto(key)}
                        before={<Icon16Clear/>}
                />
            </div>
        );

        const overlayBottom = isMobile ? (
            <div className="gallery-thumb__overlay gallery-thumb__overlay--bottom" key={`toolbar-${key}`}>
                {canChangeAngle &&
                    <Button mode="primary" size="m" className="btn-gallery-actions"
                            onClick={() => this.openChangeAngle(key)}
                            before={<Icon20ListPenOutline/>}
                            aria-label="Сменить ракурс"
                    />}
                <Button mode="primary" size="m" className="btn-gallery-actions"
                        onClick={() => this.rotatePhoto(key, 'right')}
                        before={<Icon20RotateRight/>}
                />
                <Button mode="primary" size="m" className="btn-gallery-actions"
                        onClick={() => this.rotatePhoto(key, 'left')}
                        before={<Icon20RotateLeft/>}
                />
            </div>
        ) : null;

        return (
            <div className="gallery-thumb" key={`thumb-${key}`} style={{width: thumbSize}}>
                <div className="gallery-thumb__frame" style={{width: thumbSize, height: thumbSize}}>
                    {imageElement}
                    {overlayTop}
                    {overlayBottom}
                </div>
            </div>
        );
    }

    render() {
        const {
            images = {},
            title = "Фотографии",
            showAddButton = true,
            base_url,
            destination = "monitoring",
            eventName,
            PhotoComponent = TakeAPhotoToQueue,
            fancyboxGroup = 'gallery',
            readOnly = false,
            emptyMessage = "Нет фотографий",
            galleryStyle = {},
            angles = [],
            angleId
        } = this.props;

        const imageKeys = Array.isArray(images) ?
            images.map((_, index) => index) :
            Object.keys(images);

        const nextKey = this.getNextKey();
        const images_url = base_url.replace("frontend/", '');

        // В режиме readOnly не показываем модальные окна
        const modals = !readOnly ? (
            <ModalRoot activeModal={this.state.activeModal}>
                <ModalPage
                    settlingHeight={100}
                    id={constants.MODAL_TAKE_A_PHOTO}
                    onClose={this.modalBack}
                >
                    <PhotoComponent
                        eventName={eventName}
                        multipleEventName={this.props.multipleEventName}
                        destination={destination}
                        numImage={this.state.numImage}
                        hidePhotos={() => this.setActiveModal(null)}
                        url={images_url}
                        openErrorNoty={this.openErrorNoty}
                        angles={angles}
                        angleId={angleId}
                    />
                </ModalPage>
                {angles.length > 0 &&
                    <ModalPage
                        settlingHeight={50}
                        id={MODAL_CHANGE_ANGLE}
                        onClose={this.modalBack}
                        header={
                            <ModalPageHeader
                                after={<PanelHeaderButton aria-label="Закрыть"
                                                          onClick={this.modalBack}><Icon24Cancel/></PanelHeaderButton>}>
                                Укажите ракурс
                            </ModalPageHeader>
                        }
                    >
                        <Div>
                            {angles.map(angle => (
                                <SimpleCell
                                    key={`change-angle-${angle.id}`}
                                    onClick={() => this.applyChangeAngle(angle.id)}
                                >
                                    {angle.title}
                                </SimpleCell>
                            ))}
                            <SimpleCell onClick={() => this.applyChangeAngle(0)}>
                                Без ракурса
                            </SimpleCell>
                        </Div>
                    </ModalPage>}
            </ModalRoot>
        ) : null;

        // Фильтруем изображения для readOnly режима (показываем только с hasImage: true)
        const filteredImageKeys = readOnly ?
            imageKeys.filter(key => {
                const item = Array.isArray(images) ? images[key] : images[key];
                return item && item.hasImage;
            }) : imageKeys;

        const hasImages = filteredImageKeys.length > 0;

        return (
            <SplitLayout modal={modals}>
                <SplitCol>
                    {title ? (
                        <Div>
                            <Title>{title}</Title>
                        </Div>
                    ) : null}
                    <Div className="incoming-photos-gallery" style={galleryStyle}>
                        {readOnly && !hasImages ? (
                            <p>{emptyMessage}</p>
                        ) : (
                            <Fancybox key={`PhotoGallery-${getGUID()}`}>
                                {!readOnly && showAddButton && (
                                    <div className="main-catalog_product-wrapper_avatar"
                                         style={{width: AdaptivityContext.isMobile ? '128px' : '268px'}}>
                                        <Button
                                            mode="secondary"
                                            onClick={() => this.getPhoto(nextKey)}
                                            style={{width: AdaptivityContext.isMobile ? '128px' : '268px'}}
                                        >
                                            <Icon28PicturePlusOutline height={AdaptivityContext.isMobile ? 120 : 260}/>
                                        </Button>
                                    </div>
                                )}
                                {filteredImageKeys.map((key) => {
                                    const item = Array.isArray(images) ? images[key] : images[key];
                                    if (!item) return null;

                                    const renderedImage = this.renderImage(item, key);
                                    if (!renderedImage) return null;

                                    return (
                                        <div key={`wrapper-${key}`} className="main-catalog_product-wrapper_avatar"
                                             style={{width: AdaptivityContext.isMobile ? '128px' : '268px'}}>
                                            {renderedImage}
                                        </div>
                                    );
                                })}
                            </Fancybox>
                        )}
                    </Div>
                </SplitCol>
            </SplitLayout>
        );
    }
}

export default PhotoGallery; 